import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { toInteger } from 'lodash';

import Canvas from '../components/canvas';

import {
    closeRightPane,
    openCanvasSettingsPane
} from '../../common/actions/right-pane-action-creators';
import { openCollectionTab } from '../actions/collection-action-creators';
import { saveCanvasSettings } from '../actions/canvas-action-creators';
import { switchSideNavItems } from '../../common/actions/ui-state-action-creators';

import {
    canvasFormIsDirtySelector,
    selectedCanvasWithWidgetsSelector
} from '../selectors/canvas-selectors';
import { selectedCollectionTabIdSelector } from '../selectors/collection-selectors';
import { isEditModeSelector } from '../../common/selectors/ui-state-selectors';

export class CanvasContainer extends Component{
    componentDidMount(){
        const {
            activeCollectionTabId,
            canvas,
            match: { params: { collectionId } },
            openCollectionTab,
            switchSideNavItems
        } = this.props;

        const selectedCollectionId = toInteger( collectionId );
        const selectedCanvasMeta = {
            id: canvas.id,
            name: canvas.name,
            url: `/${collectionId}/canvas/${canvas.id}`
        };

        openCollectionTab( this.props, selectedCanvasMeta );

        if( activeCollectionTabId === null ){
            switchSideNavItems( selectedCollectionId );
        }
    }

    handleCloseSettingsPane = () => this.props.closeRightPane();

    handleOpenSettingsPane = () => {
        const { canvas, openCanvasSettingsPane } = this.props;

        openCanvasSettingsPane( canvas );
    }

    handleSaveSettings = () => {
        const { canvas: { id }, saveCanvasSettings } = this.props;

        saveCanvasSettings( id );
    }

    render(){
        const { canvas, isEditMode, isFormDirty } = this.props;

        return (
            <Canvas
                canvasDetails={canvas}
                handleOpenSettingsPane={this.handleOpenSettingsPane}
                handleCloseSettingsPane={this.handleCloseSettingsPane}
                handleSaveSettings={this.handleSaveSettings}
                isEditMode={isEditMode}
                isFormDirty={isFormDirty}
            />
        );
    }
};

CanvasContainer.propTypes = {
    activeCollectionTabId: PropTypes.number,
    canvas: PropTypes.shape( {
        description: PropTypes.string,
        id: PropTypes.number,
        name: PropTypes.string.isRequired,
    } ).isRequired,
    closeRightPane: PropTypes.func.isRequired,
    isEditMode: PropTypes.bool.isRequired,
    isFormDirty: PropTypes.bool.isRequired,
    match: PropTypes.shape( {
        params: PropTypes.shape( {
            collectionId: PropTypes.string
        } ),
    } ),
    openCanvasSettingsPane: PropTypes.func.isRequired,
    openCollectionTab: PropTypes.func.isRequired,
    saveCanvasSettings: PropTypes.func.isRequired,
    switchSideNavItems: PropTypes.func.isRequired,
};

/* istanbul ignore next */
const mapStateToProps = ( state, props ) => {
    return {
        activeCollectionTabId: selectedCollectionTabIdSelector( state ),
        canvas: selectedCanvasWithWidgetsSelector( state, props ),
        isEditMode: isEditModeSelector( state ),
        isFormDirty: canvasFormIsDirtySelector( state, props ),
    };
};

const mapStateToDispatch = {
    closeRightPane,
    openCanvasSettingsPane,
    openCollectionTab,
    saveCanvasSettings,
    switchSideNavItems,
};

export default connect( mapStateToProps, mapStateToDispatch )( CanvasContainer );
